/*  ========================================================================
    # Hooks - Use Translation
    ========================================================================  */

/**
 * How to use:
 * const __ = useTranslation();
 * __('TRANSLATION_STRING')
 *
 * @returns {function(): string}
 */
export default function useTranslation() {
  return (key, replacements = {}) => {
    let value = window.translations?.[key] || key;

    for (const [placeholder, replaceWith] of Object.entries(replacements)) {
      value = value.replaceAll(`{${placeholder}}`, replaceWith);
    }

    return value;
  };
}
